import axios from 'axios';

/**
 * Configure axios to automatically include JWT token in Authorization header
 * for all requests to protected endpoints.
 * 
 * The token is retrieved from localStorage where it's stored after login/signup.
 */

// Request interceptor: add Authorization header if token exists
axios.interceptors.request.use(
  (config) => {
    try {
      const userStr = localStorage.getItem('best_galaxy_current_user');
      if (userStr) {
        const user = JSON.parse(userStr);
        const token = user?.session_token;
        
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.error('Error reading session token:', error);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: handle 401 Unauthorized (expired/invalid token)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - clear user session and redirect to login
      const currentPath = window.location.pathname;
      
      // Don't redirect if already on auth pages
      if (!['/login', '/signup', '/forgot-password', '/reset-password', '/confirm-email'].includes(currentPath)) {
        console.warn('Session expired. Please log in again.');
        localStorage.removeItem('best_galaxy_current_user');
        
        // Redirect to login with return URL
        window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
      }
    }
    
    return Promise.reject(error);
  }
);

export default axios;
